/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_MapInputs */

const vi_grower_area_public_map = /** @type {(inputs: Grower_Area_Public_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí thửa`)
};

/**

* @param {Grower_Area_Public_MapInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_map = /** @type {((inputs?: Grower_Area_Public_MapInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_MapInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_map(inputs)
});